<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <section style="margin-bottom: 1%">
        <a-button type="primary" @click="$router.push('/addSupplier')">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('form.CreateSupplier') }}
        </a-button>
      </section>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-input
            allow-clear
            v-model.trim="formData.supplierCodes"
            :placeholder="$t(`请输入供应商名称/编码`)"
          />
        </a-col>
        <a-col :span="8">
          <a-select
            allowClear
            :placeholder="$t(`form.pleaseChoose`) + $t(`form.BizMode`)"
            style="width: 100%"
            v-model="bizMode"
            @change="chooseCooperationMode"
          >
            <a-select-option :key="key" :value="key" v-for="(item, key) in bizModeList">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8">
          <date-range-picker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseOrderStart"
            :placeholder2="[$t(`请选择创建开始时间`), $t(`请选择创建结束时间`)]"
            :start-time="formData.dateStart"
            :end-time="formData.dateEnd"
            ref="child"
          ></date-range-picker>
        </a-col>
      </a-row>
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :span="8">
          <a-button @click="queryOrderList(1)" class="btnBgc">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`form.Search`) }}
          </a-button>
          <a-button @click="resetFn" style="margin-left: 15px">
            <a-icon type="sync" />
            {{ $t(`form.Reset`) }}
          </a-button>
          <a-button @click="onExport" style="margin-left: 15px">
            <a-icon type="export" />
            {{ $t(`导出`) }}
          </a-button>
        </a-col>
      </a-row>

      <div class="table-content">
        <div class="table-header">
          <div class="row status-list-wrap">
            <a-tabs default-active-key="" @change="setSearchStatus">
              <a-tab-pane key="">
                <template slot="tab">
                  <span>{{ $t('form.All') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane :key="1">
                <template slot="tab">
                  <span>{{ $t('form.Enabled') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane :key="0">
                <template slot="tab">
                  <span>{{ $t('form.Deactivated') }}</span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>
          <ul class="action-list" v-show="tableData.length">
            <li style="margin-right: 15px">
              <!-- 启用 -->
              <a-button class="btnBgc" @click="batchEnable">
                {{ $t(`form.Enable`) }}
              </a-button>
            </li>
            <li style="margin-right: 15px">
              <!-- 停用 -->
              <a-button class="btnBgD" @click="batchDeactivate">
                {{ $t(`form.Deactivate`) }}
              </a-button>
            </li>
          </ul>
        </div>
        <div class="table-body">
          <a-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :scroll="{ x: 1500 }"
            :columns="tableColumns"
            :data-source="tableData"
            rowKey="supplierCode"
            :pagination="false"
            bordered
          >
            <template slot="SupplierCode" slot-scope="text, record">
              <a @click="onCliCkDetail(record.supplierCode)">{{ record.supplierCode }}</a>
            </template>
            <template slot="time" slot-scope="text, record">
              <div>
                <div class="time-item">{{ $t('form.CreateAt') }}：{{ record.createdAt }}</div>
              </div>
            </template>
            <template slot="SupplierStatus" slot-scope="text, record">
              {{ record.status === 1 ? $t(`form.Enabled`) : $t(`form.Deactivated`) }}
            </template>
            <template slot="BizArea" slot-scope="text, record">
              {{ record.bizArea | filterBizArea }}
            </template>
            <template slot="BizCategory" slot-scope="text, record">
              {{ record.bizCategory | filterBizCategory }}
            </template>
            <template slot="BizMode" slot-scope="text, record">
              {{ record.bizMode | filterBizMode }}
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button
                type="link"
                v-if="record.shipSupplierCode"
                @click="showModalAccountModal(record)"
              >
                {{ $t('查看初始门户账号') }}
              </a-button>
              <!-- <a-button
                v-else
                :loading="record.loading"
                type="link"
                @click="createSupplierMerchant(record)"
              >
                {{ $t('生成门户账号') }}
              </a-button> -->
            </template>
          </a-table>
        </div>
        <div class="table-footer">
          <pagination
            :pageNo="pageNo"
            :length="pageSize"
            :total-count="total"
            @paginate="paginate"
          ></pagination>
        </div>
      </div>
    </section>
    <a-modal v-model="visible" :title="modalInfo.modalTitle" :width="500" :footer="null">
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :multiple="true"
          :action="modalInfo.modalUrl"
          :data="{ buId: buId, shopCode: shopCode }"
          :headers="{ Authorization: sessionId }"
          @change="handleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          target="_blank"
          class="text-info mt10"
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ modalInfo.modalTitle }}{{ $t('form.Template') }}.xls
        </a>
      </div>
    </a-modal>
    <a-modal
      :title="$t('供应商门户注册')"
      v-model="registVisible"
      :footer="null"
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
    >
      <div class="flex-c-c flex-col">
        <p style="font-weight: bold">{{ $t('门户注册中……') }}</p>
        <a-progress type="circle" :percent="percent" />
      </div>
    </a-modal>
    <a-modal
      v-model="modalAccountVisible"
      :title="$t('供应商门户账号')"
      :width="500"
      :footer="null"
    >
      <div class="account-content">
        <div class="account-item mt10">{{ $t('商户名') }}: {{ modalAccountInfo.merchantName }}</div>
        <div class="account-item mt10">{{ $t('账号') }}: {{ modalAccountInfo.userName }}</div>
        <div class="account-item mt10">{{ $t('密码') }}: {{ modalAccountInfo.password }}</div>
        <div class="account-item mt10 text-link" @click="copyHandle">{{ $t('一键复制') }}</div>
        <div class="account-item mt10 text-link" v-if="isTest" @click="loginHandle">
          {{ $t('一键登录') }}
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import http from '@/service/axios'
import api from '@/service/api'
import { mapMutations, mapState } from 'vuex'
import pagination from '@component/pagination'
import dateRangePicker from '@component/dateRangePicker'
import { Modal } from 'ant-design-vue'
import { getCookie } from '@/common/cookie'
import { copy } from '@/common'
import moment from 'moment'
import debounce from '@/common/debounce'
var _self = {}
export default {
  name: 'vendorList',
  mounted() {
    // if (!JSON.parse(localStorage.getItem('bizModeList'))) {
    this.getBizMode()
    // }
    this.queryOrderList()
    this.sessionId = getCookie('d_session_id')
    _self = this
  },
  activated() {
    this.queryOrderList()
  },
  components: {
    pagination,
    dateRangePicker,
  },
  data() {
    return {
      sessionId: '',
      status: '',
      formData: {
        purchaseOrderSn: '',
        referenceNo: '',
        startTime: '',
        endTime: '',
        status: '',
        warehouseCode: '',
        tag: '',
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      selectedRowKeys: [],
      tableData: [],
      modalInfo: {
        modalTitle: '',
        modalDesc: '',
        modalUrl: '',
        xlsRequestUrl: '',
        xlsDownloadUrl:
          'https://erp-prod.oss-ap-southeast-1.aliyuncs.com/cloud_bird_oss_gRDnXV93qPU2SDCp/SCM/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E9%87%87%E8%B4%AD%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx', //模板下载链接
      },
      visible: false,
      bizMode: undefined,
      bizCategory: undefined,
      bizArea: undefined,
      modalAccountInfo: {},
      modalAccountVisible: false,
      timer: null,
      registVisible: false,
      percent: 0,
    }
  },
  computed: {
    ...mapState(['bizModeList']),
    tableColumns() {
      return [
        {
          dataIndex: 'SupplierCode',
          title: this.$t('form.SupplierCode'),
          key: 'supplierCode',
          scopedSlots: { customRender: 'SupplierCode' },
        },
        {
          title: this.$t('时间'),
          dataIndex: 'time',
          width: 240,
          scopedSlots: { customRender: 'time' },
        },
        {
          title: this.$t('form.SupplierName'),
          dataIndex: 'supplierName',
          key: 'supplierName',
        },
        {
          title: this.$t('form.ContactPerson'),
          key: 'contactPerson',
          dataIndex: 'linkman',
        },
        {
          title: this.$t('form.BizMode'),
          key: 'bizMode',
          dataIndex: 'bizMode',
          scopedSlots: { customRender: 'BizMode' },
        },
        {
          title: this.$t('form.Currency'),
          key: 'currency',
          dataIndex: 'currency',
        },
        {
          title: this.$t('仓库名称'),
          key: 'warehouseName',
          dataIndex: 'warehouseName',
        },
        {
          title: this.$t('form.SupplierStatus'),
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'SupplierStatus' },
        },
        {
          title: this.$t('操作'),
          key: 'action',
          width: 160,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    shopCode() {
      return this.$store.state.shopCode
    },
    buId() {
      return this.$store.getters.partyId
    },
    isTest() {
      return window.location.host.indexOf('test') > -1
    },
  },
  filters: {
    filterBizArea(val) {
      const obj = {
        cross_border: _self.$t(`form.crossborder`),
        domestic: _self.$t(`form.domestic`),
      }
      return obj[val]
    },
    filterBizCategory(val) {
      const obj = {
        warehousing: _self.$t(`form.Storage`),
        ordering: _self.$t(`form.OrderGoods`),
        promotion: _self.$t(`form.Extension`),
        gift_purchase: _self.$t(`form.ComplimentaryPurchase`),
        other: _self.$t(`form.Other`),
      }
      return obj[val]
    },
    filterBizMode(val) {
      const obj = {
        dealer: _self.$t(`form.Distribute`),
        proxy_sale: _self.$t(`form.Consignment`),
        other: _self.$t(`form.Other`),
      }
      return obj[val]
    },
  },
  methods: {
    moment,
    ...mapMutations(['setState']),
    chooseCooperationMode(value) {
      //选择合作模式
      if (value) {
        this.formData.bizMode = value
      } else {
        this.formData.bizMode = ''
      }
    },
    onCliCkDetail(id) {
      this.$router.push({
        name: 'addSupplier',
        query: { id },
      })
    },
    chooseOrderStart(date) {
      this.formData.dateStart = date.start_time
      this.formData.dateEnd = date.end_time
    },
    resetFn() {
      this.pageNo = 1
      this.pageSize = 10
      this.formData.supplierCodes = null
      this.formData.status = null
      this.formData.bizMode = null
      this.formData.bizArea = null
      this.formData.dateStart = null
      this.formData.dateEnd = null
      this.bizMode = undefined
      this.bizArea = undefined
      this.bizCategory = undefined
      this.$refs.child.clear()
      this.queryOrderList()
    },
    queryOrderList(first_page = false) {
      first_page && (this.pageNo = 1)
      this.$nextTick(() => {
        let data = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          supplierNameOrCode: this.formData.supplierCodes,
          status: this.formData.status,
          bizMode: this.formData.bizMode,
          dateStart: this.formData.dateStart,
          dateEnd: this.formData.dateEnd,
        }
        http({
          instance: this,
          type: 'post',
          url: api.supplierList,
          hasLoading: true,
          data,
          success: (res) => {
            let vendorOrderList = [...(res.result.supplierInfoVO || '')]
            this.tableData = vendorOrderList
            this.total = res.result.total
          },
        })
      })
    },
    setSearchStatus(status) {
      this.$set(this.formData, 'tag', '')
      this.$set(this.formData, 'status', status)
      this.pageNo = 1
      this.queryOrderList()
      this.selectedRowKeys = []
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    batchEnable() {
      this.batchHandle({
        modalAction: this.$t('form.Enable'),
        url: api.supplierBatchUpdateStatus,
        status: 1,
      })
    },
    batchDeactivate() {
      this.batchHandle({
        modalAction: this.$t('form.Deactivate'),
        url: api.supplierBatchUpdateStatus,
        status: 0,
      })
    },
    confirmSelect() {
      let is_empty = false
      if (this.selectedRowKeys.length === 0) {
        is_empty = true
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.SelectAtLeastOneItem`),
        })
      }
      return is_empty
    },
    batchHandle({ modalAction, url, status }) {
      if (this.confirmSelect()) return
      Modal.confirm({
        // title: 'Confirm',
        content: `${this.$t('form.Whether')} ${modalAction} ${this.$t('form.SelectSupplier')}`,
        okText: this.$t('form.Confirm'),
        cancelText: this.$t('form.Cancel'),
        onOk: () => {
          let supplierCodes = [...this.selectedRowKeys]
          this.commonHttp({
            url,
            modalAction,
            data: { supplierCodes, status },
          }).then(() => {
            this.selectedRowKeys = []
            this.queryOrderList()
            this.$nextTick(() => {
              this.$store.dispatch('querySupplierList')
            })
          })
        },
      })
    },
    commonHttp({ url, modalAction, data }) {
      return new Promise((resolve) => {
        http({
          instance: this,
          type: 'post',
          hasLoading: true,
          url,
          data,
          success: (res) => {
            this.$success({
              title: this.$t(`layer.Success`),
              content: `${modalAction}${this.$t('form.Success')}`,
            })
            resolve(res)
          },
        })
      })
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryOrderList()
    },
    handleChange(info) {
      this.shopCode = JSON.parse(localStorage.getItem('currentShop'))?.uniqueCode
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          this.queryOrderList()
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
      }
      this.visible = false
    },
    getBizMode() {
      http({
        instance: this,
        type: 'post',
        url: api.getBizModeMap,
        data: {},
        success: (res) => {
          if (localStorage.getItem('language') == 'en') {
            Object.keys(res.result).forEach((i) => {
              res.result[i] = i
            })
          }
          // console.log(res.result)
          this.setState({ bizModeList: res.result })
          localStorage.setItem('bizModeList', JSON.stringify(res.result))
        },
      })
    },
    onExport: debounce(async function () {
      let res = await http({
        url: api.getDownloadKey,
        data: {},
      })
      let url =
        api.exportSupplier +
        '?merchantCode=' +
        JSON.parse(localStorage.getItem('userSession')).merchantCode +
        `&auth-download-key=${res.result}`
      for (let item in this.formData) {
        if (this.formData[item]) {
          url += '&' + item + '=' + encodeURIComponent(this.formData[item])
        }
      }
      window.open(url)
    }),
    createSupplierMerchant(record) {
      this.$set(record, 'loading', true)
      http({
        url: api.initSupplierMerchant,
        data: {
          supplierCode: record.supplierCode,
        },
        success: (res) => {
          this.modalAccountInfo = res.result
          this.registVisible = true
          this.getRegistPercent()
          this.$set(record, 'loading', false)
          this.queryOrderList()
        },
      })
    },
    loginHandle() {
      window.open(
        `https://testsrm.shopspade.com?store_name=${this.modalAccountInfo.merchantName}&user_name=${this.modalAccountInfo.userName}&password=${this.modalAccountInfo.password}`
      )
    },
    copyHandle() {
      let str = `已为您生成门户账号
商户名：${this.modalAccountInfo.merchantName}
账户：${this.modalAccountInfo.userName}
密码：${this.modalAccountInfo.password}

访问地址：https://srm.shopspade.com?store_name=${this.modalAccountInfo.merchantName}&user_name=${this.modalAccountInfo.userName}&password=${this.modalAccountInfo.password}`
      copy(str)
    },
    showModalAccountModal(record) {
      this.modalAccountInfo = record.shipSupplier
      this.modalAccountVisible = true
      this.copyHandle()
    },
    async getRegistPercent() {
      if (this.percent === 100) {
        clearTimeout(this.timer)
        this.timer = null
        this.registVisible = false
        this.modalAccountVisible = true
        this.copyHandle()
        return
      }
      let res = await http({
        url: api.queryRegisterProgress,
        data: {
          merchantName: this.modalAccountInfo.merchantName,
        },
      })
      this.percent = res.result.progress
      this.timer = setTimeout(async () => {
        this.getRegistPercent()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
.btnBgD {
  background-color: #ff4d4f;
  color: #ffffff;
}
.batchBgc {
  color: #0088ff;
  border-color: #0088ff;
}
.action-list {
  display: flex;
}
.flex-btns {
  max-width: 120px;
  &.flex {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .t-btn {
    cursor: pointer;
    margin-right: 10px;
    color: $primary-color;
    white-space: nowrap;
  }
}
.upload-content {
  padding: 20px;
}
.mt10 {
  margin-top: 10px;
  display: block;
}
.time-item {
  font-size: 13px;
}
</style>
